import { TRPCClientError } from '@trpc/client';

export function getMutationErrorMessage(error: unknown): string {
  return error instanceof TRPCClientError
    ? error.message
    : 'An unexpected error occurred';
}

export function hasOrderChanged<T>(
  current: T[],
  original: T[],
  getId: (item: T) => string,
  getOrder: (item: T, index: number) => number
): boolean {
  if (current.length !== original.length) return true;

  const originalMap = new Map(
    original.map((item, i) => [getId(item), getOrder(item, i)])
  );

  for (let i = 0; i < current.length; i++) {
    const item = current[i];
    const originalOrder = originalMap.get(getId(item));
    if (originalOrder === undefined) return true;
    if (originalOrder !== getOrder(item, i)) return true;
  }

  return false;
}
